"use client"
import { useLocation } from "react-router-dom"
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Avatar,
  Chip,
  Button,
  Divider,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material"
import { Email, Phone, LocationOn, FilePresent, Edit, Download, Close } from "@mui/icons-material"
import { useState } from "react"
import moment from "moment"

export default function GalaxyCustomersDetail() {
  const { state } = useLocation()
  const baseUrl = process.env.REACT_APP_IMAGE_BASE_URL
  const [openImageDialog, setOpenImageDialog] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  if (!state) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">No customer data available</Typography>
      </Box>
    )
  }

  const customer = state?.item
  const profile = customer.customerProfile

  console.log(customer ,"baseUrl")
  const handleImageClick = (imageUrl, title) => {
    setSelectedImage({ url: imageUrl, title })
    setOpenImageDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenImageDialog(false)
    setSelectedImage(null)
  }

  const getStatusColor = (isActive) => {
    return isActive ? "success" : "error"
  }

  const getStatusLabel = (isActive) => {
    return isActive ? "Active" : "Inactive"
  }

  return (
    <Box sx={{ p: 3, backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      {/* Header Section */}
      <Card sx={{ mb: 3, boxShadow: 3 ,borderRadius:"12px" }}>
        <CardContent >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm="auto">
              <Avatar src={baseUrl + customer.picture} sx={{ width: 120, height: 120, boxShadow: 2 }} />
            </Grid>
            <Grid item xs={12} sm>
              <Stack spacing={1}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    {customer.name}
                  </Typography>
                  <Chip
                    label={getStatusLabel(customer.is_active)}
                    color={getStatusColor(customer.is_active)}
                    variant="outlined"
                  />
                </Box>
                <Typography variant="body2" color="textSecondary">
                  ID: {customer.ref_id}
                </Typography>
               
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Quick Contact Info */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={6}>
          <Card sx={{ boxShadow: 2,borderRadius:"12px"  }}>
            <CardContent>
              <Stack spacing={1}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Phone sx={{ color: "#0066cc" }} />
                  <Typography variant="caption" color="textSecondary">
                    Phone
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {customer.uae_phone}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card sx={{ boxShadow: 2 ,borderRadius:"12px" }}>
            <CardContent>
              <Stack spacing={1}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Email sx={{ color: "#0066cc" }} />
                  <Typography variant="caption" color="textSecondary">
                    Email
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {customer.email}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
       
        
      </Grid>

      {/* Main Content Grid */}
      <Grid container spacing={3}>
        {/* Personal Information */}
        <Grid item xs={12} md={12}>
          <Card sx={{ boxShadow: 3, height: "100%" ,borderRadius:"12px"  }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                Personal Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TableContainer>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", width: "40%" }}>Full Name</TableCell>
                      <TableCell>{customer.name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Gender</TableCell>
                      <TableCell sx={{ textTransform: "capitalize" }}>{profile?.gender}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Nationality</TableCell>
                      <TableCell>{profile?.nationality?.name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Authorized Person Name</TableCell>
                      <TableCell>{profile?.ap_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Authorized Person  Phone</TableCell>
                      <TableCell>{profile?.ap_number}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Currency</TableCell>
                      <TableCell sx={{ textTransform: "uppercase" }}>{profile?.currency}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>

        {/* Business Information */}
        {/* <Grid item xs={12} md={6}>
          <Card sx={{ boxShadow: 3, height: "100%" ,borderRadius:"12px"  }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                Business Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TableContainer>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", width: "40%" }}>Customer Type</TableCell>
                      <TableCell>{profile?.customer_type_id}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Trade License</TableCell>
                      <TableCell>{profile?.trade_license_number || "N/A"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>VAT Number</TableCell>
                      <TableCell>{profile?.vat_number || "N/A"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Import</TableCell>
                      <TableCell>
                        <Chip
                          label={profile?.import ? "Yes" : "No"}
                          color={profile?.import ? "success" : "default"}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Export</TableCell>
                      <TableCell>
                        <Chip
                          label={profile?.export ? "Yes" : "No"}
                          color={profile?.export ? "success" : "default"}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Trusted</TableCell>
                      <TableCell>
                        <Chip
                          label={profile?.is_trusted === null ? "Pending" : profile?.is_trusted ? "Yes" : "No"}
                          color={profile?.is_trusted === null ? "warning" : profile?.is_trusted ? "success" : "error"}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid> */}

        {/* Address */}
        <Grid item xs={12}>
          <Card sx={{ boxShadow: 3 ,borderRadius:"12px"  }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                Address
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                <LocationOn sx={{ color: "#0066cc", mt: 0.5 }} />
                <Typography variant="body2">{profile?.address}</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Documents */}
        <Grid item xs={12}>
          <Card sx={{ boxShadow: 3 ,borderRadius:"12px"  }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                Documents & Verification
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                {customer.picture && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Paper
                      sx={{
                        p: 2,
                        textAlign: "center",
                        cursor: "pointer",
                        transition: "all 0.3s",
                        "&:hover": {
                          boxShadow: 3,
                          transform: "translateY(-4px)",
                        },
                      }}
                      onClick={() => handleImageClick(customer.picture, "Profile Picture")}
                    >
                      <Box
                        component="img"
                        src={baseUrl + customer.picture}
                        alt="Profile"
                        sx={{
                          width: "100%",
                          height: 150,
                          objectFit: "cover",
                          borderRadius: 1,
                          mb: 1,
                        }}
                      />
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Profile Picture
                      </Typography>
                    </Paper>
                  </Grid>
                )}
                {profile?.passport && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Paper
                      sx={{
                        p: 2,
                        textAlign: "center",
                        cursor: "pointer",
                        transition: "all 0.3s",
                        "&:hover": {
                          boxShadow: 3,
                          transform: "translateY(-4px)",
                        },
                      }}
                      onClick={() => handleImageClick(profile?.passport, "Passport")}
                    >
                      <Box
                        component="img"
                        src={baseUrl + profile?.passport}
                        alt="Passport"
                        sx={{
                          width: "100%",
                          height: 150,
                          objectFit: "cover",
                          borderRadius: 1,
                          mb: 1,
                        }}
                      />
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Passport
                      </Typography>
                      <Typography variant="caption" display="block" color="textSecondary">
                        Expires: {new Date(profile?.passport_expiry).toLocaleDateString()}
                      </Typography>
                    </Paper>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* System Information */}
        <Grid item xs={12}>
          <Card sx={{ boxShadow: 3 ,borderRadius:"12px" }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                System Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TableContainer>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", width: "30%" }}>Created By</TableCell>
                      <TableCell>{customer.creator?.name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Created At</TableCell>
                      <TableCell>{moment(customer.created_at).format("DD-MM-YYYY hh:mm a")}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Password Changed</TableCell>
                      <TableCell>
                        <Chip
                          label={customer.password_change ? "Yes" : "No"}
                          color={customer.password_change ? "success" : "warning"}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                      <TableCell>
                        <Chip
                          label={getStatusLabel(customer.is_active)}
                          color={getStatusColor(customer.is_active)}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Image Dialog */}
      <Dialog open={openImageDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {selectedImage?.title}
          <Close onClick={handleCloseDialog} sx={{ cursor: "pointer" }} />
        </DialogTitle>
        <DialogContent>
          {selectedImage && (
            <Box
              component="img"
              src={baseUrl + selectedImage.url}
              alt={selectedImage.title}
              sx={{ width: "100%", borderRadius: 1 }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  )
}
